import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Order, Language } from "../../../../../../../services";
import { StyledRow } from "../../../../../../common";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const PickupAddressCellContent: React.FC<PickupAddressCellContent.Props> = ({
	item,
	language,
}) => {
	const { t } = useTranslation();

	const { content, backgroundColor } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isLanguageMatched =
			item?.cellsForTableSettings?.lang === language;

		const preparedCell = item?.cellsForTable?.[ColumnId.PickupAddress];

		if (
			isCellsReady &&
			isLanguageMatched &&
			preparedCell != null
		) {
			return preparedCell;
		}

		return cellProcessing(item, t);
	}, [item, language, t]);

	return (
		<StyledRow
			bgC={backgroundColor ? "#ffffff" : undefined}
			w="100%"
			h="100%"
		>
			<CellContentRoot
				backgroundColor={backgroundColor}
				alignItems="center"
				h="100%"
				w="100%"
			>
				{content}
			</CellContentRoot>
		</StyledRow>
	);
};

declare namespace PickupAddressCellContent {
	interface Props {
		item: Order.Model;
		language: Language;
	}
}

export default PickupAddressCellContent;
